import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { useFunnelGraphOption, FunnelGraphOptions } from './container/options'
import { useFunnelGraphModel } from './container/model'
import { useFunnelGraphOptionRender } from './container/render'
import { useFunnelGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { FunnelChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  FunnelChart,
  CanvasRenderer,
])

export const FunnelGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options, filterText } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useFunnelGraphOption({ options, dashBoard, targetList })
	const graphData = useFunnelGraphModel({ dataList, conditions, filterText, graphOption })
	const renderOption = useFunnelGraphOptionRender({ graphData })
  const events = useFunnelGraphEvents({ graphOption, onChangeCondition })

  useEffect(
		() => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )

	const { axisDef, valueDef } = graphOption
	return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        dashBoard={dashBoard}
        keys={[axisDef?.key, valueDef?.key]}
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const FunnelGraphFactory: GraphType = {
  title: '漏斗グラフ',
  options: FunnelGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <FunnelGraph<T> {...props} />,
}
